/**
 * Functions that operate on enum objects.
 *
 * An enum is defined as an object whose attributes map a string as the
 * attribute name and a Symbol object wrapping a string that identifies a unique
 * event name.
 *
 * @module component/util/enumtool
 */

/**
 * Retrieve the value held by the enum variant.
 *
 * As long as the variant is a Symbol object created with a value, this function
 * will return that value as a string
 *
 * @param {Symbol} variant
 * A symbol object that contains the value that will be returned as a string.
 *
 * @returns {string}
 * This is the value held in the variant object converted into a string.
 *
 * @throws {TypeError}
 * An exception is thrown if the variant parameter is not a Symbol object.
 *
 * @example
 * const EnumKind = {
 *    Life: Symbol(42)
 * }
 *
 * // Returns the string '42'
 * let answer = enum_value(EnumKind.Life)
 *
 */
export function enum_value(variant) {
    let variant_type = typeof variant;
    if (variant_type !== 'symbol') {
        let errmsg = `Expected symbol, got ${variant_type} instead`;
        throw new TypeError(errmsg);
    }

    return variant.toString().slice(7, -1);
}
